import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faExclamationCircle, faInbox, faSearch} from '@fortawesome/free-solid-svg-icons';

const VARIANTS = {
    noData: { icon: faInbox, defaultMessage: "No data to display" },
    search: { icon: faSearch, defaultMessage: "Select filters and search to view data" },
    error: { icon: faExclamationCircle, defaultMessage: "Something went wrong" },
};

const EmptyTableState = ({ message, variant = "noData" }) => {
    const config = VARIANTS[variant] || VARIANTS.noData;

    return (
        <div className="table-empty-state">
            <FontAwesomeIcon icon={config.icon} className="table-empty-icon" />
            <p className="table-empty-message">{message || config.defaultMessage}</p>
        </div>
    );
};

export default EmptyTableState;
